// extracted by mini-css-extract-plugin
export var component = "ErrorMessage-module--component--NBHrr";
export var error = "ErrorMessage-module--error--92cU0";
export var icon = "ErrorMessage-module--icon--DNeN0";
export var info = "ErrorMessage-module--info--mQ+Ll";
export var textError = "ErrorMessage-module--textError--yENo+";
export var textInfo = "ErrorMessage-module--textInfo--6AM3T";
export var textWarning = "ErrorMessage-module--textWarning--AuCUt";
export var warning = "ErrorMessage-module--warning--VYCXq";